// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import { Button, Tooltip } from '@chakra-ui/react';
import { MdInfoOutline } from 'react-icons/md';

import { color } from 'styles/colors';

interface ToolTipProps {
  text: string;
}

export default function ToolTip({ text }: ToolTipProps) {
  const containerRef = useRef<HTMLDivElement>(null); // Ref para o container principal
  const [isOpen, setIsOpen] = useState(false);

  // Detecta clique fora do componente
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false); // Fecha a lista se o clique for fora do container
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside); // Limpa o listener ao desmontar
    };
  }, []);

  return (
    <Tooltip ref={containerRef} label={text} isOpen={isOpen}>
      <Button
        backgroundColor={'transparent'}
        onClick={() => setIsOpen(item => !item)}
      >
        <MdInfoOutline size={20} color={color.interface.darkgray} />
      </Button>
    </Tooltip>
  );
}
